// @ts-nocheck

export type TicketGetWithTicketCommentsContactToOwner = typeof TicketGetWithTicketCommentsContactToOwner[keyof typeof TicketGetWithTicketCommentsContactToOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactToOwner = {
  true: 'true',
  false: 'false',
} as const;
